import { useQuery } from "react-query";
import { fetchAddress } from "../queries/address.queries";

export const useAddress = (id: number | string | null | undefined) => {
	return useQuery(["address", id], () => {
		try {
			return fetchAddress(id);
		} catch (err) {
			return null;
		}
	});
};
